import { LogOut } from 'lucide-react'
import { useAuth } from '@/contexts/AuthProvider'

const LOGO_URL = 'https://storage.googleapis.com/trainingmatrix/images/tmlogoiconv2.png'

// Shown instead of the app when every profile on this login has been archived or removed.
// Rendered outside MobileLayout so the header's notification hooks never start.
export default function AccessRemovedScreen({ companies = [] }) {
  const { signOut } = useAuth()
  const names = companies.length ? companies.join(', ') : 'your company'

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="flex-shrink-0 pt-16 pb-8 px-6 flex flex-col items-center text-center">
        <img
          src={LOGO_URL}
          alt="AI Training Matrix"
          className="w-16 h-16 rounded-2xl shadow-xl drop-shadow-md"
        />
        <h1 className="text-2xl font-bold text-slate-900 mt-5">Access removed</h1>
        <p className="text-sm text-slate-500 mt-2 max-w-sm">
          You no longer have access to {names}, so its records aren't available. If you think this is a
          mistake, contact your administrator.
        </p>
      </div>

      <div className="flex-1 px-6 pb-8">
        <div className="max-w-sm mx-auto">
          <button
            type="button"
            onClick={signOut}
            className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium rounded-xl transition-colors flex items-center justify-center gap-2"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </button>
        </div>
      </div>
    </div>
  )
}
